import { SvgFactory } from '../../Svg';

const ShareIcon = SvgFactory(
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="black">
        <path d="M13.833 4.16683L12.6497 5.35016L11.3247 4.02516V13.3335H9.67467V4.02516L8.34967 5.35016L7.16634 4.16683L10.4997 0.833496L13.833 4.16683ZM17.1663 8.3335V17.5002C17.1663 18.4168 16.4163 19.1668 15.4997 19.1668H5.49967C4.57467 19.1668 3.83301 18.4168 3.83301 17.5002V8.3335C3.83301 7.4085 4.57467 6.66683 5.49967 6.66683H7.99967V8.3335H5.49967V17.5002H15.4997V8.3335H12.9997V6.66683H15.4997C16.4163 6.66683 17.1663 7.4085 17.1663 8.3335Z" />
    </svg>
);

export default ShareIcon;
